import { combineReducers } from "redux";
import studentSelectReducer from "./studentSelectReducer";
import studentsReducer from "./studentsReducer";
import userReducer from "./userReducer";


export const rootReducer = combineReducers({userState:userReducer,studentState:studentsReducer,studentSelectState:studentSelectReducer})